import { render, staticRenderFns } from "./ImportCustomersDialog.vue?vue&type=template&id=32bc37bc&"
import script from "./ImportCustomersDialog.vue?vue&type=script&lang=js&"
export * from "./ImportCustomersDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports